// Brand glyphs not available in lucide-react (TikTok, ORCID).
export const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M12.53 2h2.98c.17 1.02.63 1.96 1.32 2.72.69.76 1.6 1.27 2.6 1.46V9.2c-1.4-.03-2.76-.44-3.94-1.18v6.2c0 1.3-.4 2.57-1.15 3.63a6.03 6.03 0 0 1-4.98 2.55A5.85 5.85 0 0 1 4 14.5a5.85 5.85 0 0 1 6.32-5.82v3.06a2.83 2.83 0 0 0-1.02-.19 2.77 2.77 0 1 0 2.77 2.77V2z" />
  </svg>
);

export const OrcidIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zM7.369 4.378c.525 0 .947.431.947.947s-.422.947-.947.947a.95.95 0 0 1-.947-.947c0-.525.422-.947.947-.947zm-.722 3.038h1.444v10.041H6.647V7.416zm3.562 0h3.9c3.712 0 5.344 2.653 5.344 5.025 0 2.578-2.016 5.025-5.325 5.025h-3.919V7.416zm1.444 1.303v7.444h2.297c3.272 0 4.022-2.484 4.022-3.722 0-2.016-1.284-3.722-4.097-3.722h-2.222z" />
  </svg>
);
